// app/javascript/controllers/tickets_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["list", 'template']

    addRow(event) {
        event.preventDefault();
        const template = this.templateTarget.content.cloneNode(true);
        const turboFrame = template.querySelector("turbo-frame");
        // Assign a unique id for the new row (e.g. using timestamp)
        turboFrame.id = `ticket_consignment_new_${Date.now()}`;
        const firstChild = this.listTarget.firstChild;
        this.listTarget.insertBefore(template, firstChild);
    }

}